/**
 * valumize API for managing funds
 * Lorem ipsum ...
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AiSetupAcceptMethod = 'INDIVIDUAL' | 'BULK' | 'EDIT';

export const AiSetupAcceptMethod = {
    Individual: 'INDIVIDUAL' as AiSetupAcceptMethod,
    Bulk: 'BULK' as AiSetupAcceptMethod,
    Edit: 'EDIT' as AiSetupAcceptMethod
};

